import SlateBlock, { SlateInline } from './SlateBlock';
export default SlateBlock;
export { SlateInline };